export enum AccountState {
  ACTIVE = "Active",
  BAN = "Ban",
}
